import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Section } from 'src/models/question.model';
import { PatientTerm } from 'src/models/questionnaire-response.model';


@Pipe({
  name: 'filterSection',
  standalone: true
})
export class FilterSectionPipe implements PipeTransform {

  transform(sections: Section[] | undefined, sectionName: string): any {
    if (typeof sections != 'undefined') {
      return sections.filter((sec: Section) => {
        return sec.sectionName == sectionName;
      });
    }
  }

}

@Pipe({ 
  name: 'replacePatientTerm', 
  standalone: true 
})
export class ReplacePatientTermPipe implements PipeTransform {
  transform(defaultText: string, patientTermText: PatientTerm[], patientTerm: string): string {

    if (!defaultText || !patientTermText || !patientTerm) {
      return defaultText;
    }

    let returnText = patientTermText.find(p => p.patientTerm?.toLocaleLowerCase() == patientTerm.toLocaleLowerCase())?.text;

    return !returnText ? defaultText : returnText;

  }
}

@Pipe({
  name: 'sanitizeHtml',
  standalone: true
})
export class SanitizeHtmlPipe implements PipeTransform {

  constructor(private _sanitizer: DomSanitizer) {
  }

  transform(v: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(v);
  }
}